import React from 'react';
import { useTheme, useMediaQuery, Box, Typography } from '@mui/material';

const ResponsiveGatekeeper = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isMobile) {
    return (
      <Box
        display="flex"
        height="100vh"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        p={2}
      >
        <Typography variant="h5">
          This app is only supported on mobile devices.
          <br />
          Please switch to a smaller screen.
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ResponsiveGatekeeper;
